import React from "react"

import { ButtonPrimary } from "../../../clux-ui/components"
import { STEPS } from "../../../enums/ateliers"
import BotMessage from "./components/BotMessage"
import ChoiceButtons from "./components/ChoiceButtons"
import { BotProps } from "./config/interfaces"
import { useChatbotEngine } from "./useChatbotEngine"

import "./style.scss"

const Bot = ({ params, setParams, story }: BotProps) => {
  const { messages, question, canAnswer, goToNode, onBotMessageDone } =
    useChatbotEngine(story)

  return (
    <>
      <ButtonPrimary
        onClick={() => setParams({ ...params, step: STEPS.PARAMETRES })}
      >
        Quitter
      </ButtonPrimary>
      <div className="chat">
        {messages.map((msg, index) => (
          <BotMessage
            key={msg.id}
            text={msg.text}
            onDone={() => {
              if (index === messages.length - 1) {
                onBotMessageDone()
              }
            }}
          />
        ))}

        {question?.type === "choice" && canAnswer && (
          <ChoiceButtons
            choices={question.choices}
            onSelect={choice => goToNode(choice.next)}
          />
        )}

        {/* TODO _ afficher reponse du joueur dans le chat */}

        {/* TODO _ reponse libre */}
        {/* TODO _ reponse clic image */}
      </div>
    </>
  )
}

export default Bot
